export const phaseChangeColumnNames = [
  {
    name: 'date',
    label: 'Date',
  },
  {
    name: 'title',
    label: 'Title',
  },
];

export const multiTargetPhaseChangeColumnNames = [
  {
    name: 'target',
    label: 'Target',
  },
  ...phaseChangeColumnNames,
];

export const trialAverageColumnNames = [
  {
    name: 'target',
    label: 'Target',
  },
  {
    name: 'value',
    label: 'Average',
  },
];

export const durationTrialAverageColumnNames = [
  {
    name: 'target',
    label: 'Target',
  },
  {
    name: 'average',
    label: 'Average',
  },
  {
    name: 'total',
    label: 'Total',
  },
];

export const TREATMENT_PLAN_COLUMN_NAMES = [
  { name: 'treatmentPlan', label: 'Treatment plan' },
  { name: 'start', label: 'Start' },
  { name: 'end', label: 'End' },
  { name: 'status', label: 'Status' },
];

export const chartColors = ['#6A4C93', '#36949D', '#8AC926', '#FFCA3A', '#FF595E'];
export const DURATION_PREFIX = '__DURATION__';
